import React from 'react';

import GenericEquityCalculator from '@lendi-jam/equity-calculator';
import { embedMarketingTrackingIntoURL } from '@lendi-jam/jam-link';
import parse from 'html-react-parser';

import { GenericEquityCalculatorContent } from '#contentTypes/GenericEquityCalculator';

interface PrismicGenericEquityCalculatorProps {
  component: GenericEquityCalculatorContent;
}

const PrismicGenericEquityCalculator: React.FC<PrismicGenericEquityCalculatorProps> = ({ component: { primary } }) => {
  if (!primary) {
    return null;
  }

  return (
    <GenericEquityCalculator
      calculatorHeading={primary.calculator_heading?.text}
      helpText={primary.help_text?.html && parse(primary.help_text?.html)}
      radioTooltipContent={primary.radio_tooltip_content?.html && parse(primary.radio_tooltip_content?.html)}
      resultBody={primary.result_body?.text}
      resultHeading={primary.result_heading?.text}
      disclaimer={primary.disclaimer?.text}
      buttonLink={embedMarketingTrackingIntoURL(primary.button_link?.url)}
      buttonText={primary.button_text?.text}
    />
  );
};

export default PrismicGenericEquityCalculator;
